"use strict";

var _taggedTemplateLiteral = require("/root/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditButton = exports.AmountContainer = exports.Label = exports.Container = void 0;

var _stylitas = require("@creditas/stylitas");

var _styleUtilities = require("@creditas-lab/style-utilities");

var _typography = require("@creditas-lab/typography");

var _GhostButton = require("../GhostButton");

var Container = _stylitas.styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin: 16px 0 12px 0;\n\n  ", "\n"])), _styleUtilities.media.md(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    margin: 24px 0 0 0;\n  "]))));

exports.Container = Container;
var Label = (0, _stylitas.styled)(_typography.Typography)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  margin-bottom: 4px;\n\n  ", "\n"])), _styleUtilities.media.md(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    margin-bottom: 8px;\n  "]))));
exports.Label = Label;

var AmountContainer = _stylitas.styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"])));

exports.AmountContainer = AmountContainer;
var EditButton = (0, _stylitas.styled)(_GhostButton.GhostButton)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral([""])));
exports.EditButton = EditButton;